import { BitmapCoordinatesRenderingScope, CanvasRenderingTarget2D } from 'fancy-canvas'
import { ICustomSeriesPaneRenderer, PaneRendererCustomData, PriceToCoordinateConverter, Time } from 'lightweight-charts'
import { StackedBarsData } from './data'
import { StackedBarsSeriesOptions } from './options'

export class StackedBarsSeriesRenderer<TData extends StackedBarsData>
    implements ICustomSeriesPaneRenderer {
    _data: PaneRendererCustomData<Time, TData> | null = null
    _options: StackedBarsSeriesOptions | null = null

    draw(
        target: CanvasRenderingTarget2D,
        priceConverter: PriceToCoordinateConverter
    ): void {
        target.useBitmapCoordinateSpace(scope =>
            this._drawImpl(scope, priceConverter)
        )
    }

    update(
        data: PaneRendererCustomData<Time, TData>,
        options: StackedBarsSeriesOptions
    ): void {
        this._data = data
        this._options = options
    }

    _drawImpl(
        renderingScope: BitmapCoordinatesRenderingScope,
        priceToCoordinate: PriceToCoordinateConverter
    ): void {
        if (
            this._data === null ||
            this._data.bars.length === 0 ||
            this._data.visibleRange === null ||
            this._options === null
        ) {
            return
        }
        const { context: ctx } = renderingScope;
        const { colors, hoveredTime} = this._options;

        const dpr = window.devicePixelRatio;
        let {from, to} = this._data.visibleRange;
        const barWidth = this._options.barWidth * this._data.barSpacing * dpr;
        const bars = this._data.bars;
        from = Math.max(from, 0);
        const zeroY = (priceToCoordinate(0) ?? 0)*dpr;
        to = Math.min(to - 1, this._data.bars.length - 1)
        for (let i=from; i <= to; i++) {
            const bar = bars[i];
            const count = bar.originalData.values?.length || 1
            const singleBarWidth = barWidth / (count + 1);
            let  rendereBarWidth = singleBarWidth;
            const leftSpace: number = (singleBarWidth / 2);
            let startX =  (bar.x)*dpr - singleBarWidth;
            const hoveredX = hoveredTime ? this._options.chartApi?.timeScale().timeToCoordinate(hoveredTime) : null;
            const expanded = bar.x === hoveredX;

            if (expanded) {
                startX -= (singleBarWidth/2);
                rendereBarWidth *= 1.5;
            }

            bar.originalData.values.forEach((value, i) => {
                const startY = Math.abs(priceToCoordinate(value))*dpr

                if (value === 0) {
                    startX += rendereBarWidth;
                    return;
                };

                ctx.beginPath();
                const barHeight = zeroY - startY;
                ctx.rect(startX, zeroY - barHeight, rendereBarWidth, barHeight);
                const color = colors[i] || '#ffffff80';
                // const opacity = getOpacityFromHexCode(color)
                ctx.fillStyle = color.substring(0, 7);
                ctx.globalAlpha = 0.3;
                ctx.fill();
                ctx.closePath();
                startX += rendereBarWidth
            })
        }
    }
}
